import React from 'react';
import ConsultationForm from '../components/ConsultationForm';

const konzultace = () => <ConsultationForm />;

export default konzultace;
